"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = interopDefault;
// https://github.com/moment/moment/issues/3650
function interopDefault(m) {
    return m["default"] || m;
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/lib/_util/interopDefault.js
// module id = 476
// module chunks = 1